import React from 'react'
import { UseFormReturn } from 'react-hook-form'

import { CompanyData } from '../../api/get-company-date/types'

export const useAutoSetInfo = (
	methods: UseFormReturn<{ companyName: string; inn: string; ogrn: string }, any>,
	selected: CompanyData | null | string
) => {
	React.useEffect(() => {
		if (!selected || typeof selected === 'string') {
			return
		}

		methods.setValue('inn', selected.data.inn, {
			shouldValidate: true,
			shouldDirty: true,
		})

		methods.setValue('ogrn', selected.data.ogrn, {
			shouldValidate: true,
			shouldDirty: true,
		})
	}, [selected, methods])
}